const AwsConfig = {
  s3: {
    REGION: process.env.NEXT_PUBLIC_AMPLIFY_S3_REGION,
    BUCKET: process.env.NEXT_PUBLIC_AMPLIFY_S3_BUCKET,
  },
  apiGateway: {
    REGION: process.env.NEXT_PUBLIC_AMPLIFY_API_GATEWAY_REGION,
    URL: process.env.NEXT_PUBLIC_AMPLIFY_API_GATEWAY_URL,
  },
  cognito: {
    REGION: process.env.NEXT_PUBLIC_AMPLIFY_COGNITO_REGION,
    USER_POOL_ID: process.env.NEXT_PUBLIC_AMPLIFY_COGNITO_USER_POOL_ID,
    APP_CLIENT_ID: process.env.NEXT_PUBLIC_AMPLIFY_COGNITO_APP_CLIENT_ID,
    IDENTITY_POOL_ID: process.env.NEXT_PUBLIC_AMPLIFY_COGNITO_IDENTITY_POOL_ID,
  },
}

export default AwsConfig
